export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04]
};

export const variants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    hide: {
        opacity: 0
    },
    show: {
        opacity: 1
    },
    off: {
        backgroundColor: '#fff',
        border: '2px solid #ddd'
    },
    on: {
        backgroundColor: '#edf0f6',
        border: '2px solid #607ca7'
    },
    tHide: {
        left: '.25rem',
        backgroundColor: '#ccc',
    },
    tShow: {
        left: '1.5rem',
        backgroundColor: '#607ca7',
    },
    lHide: {
        color: '#888'
    },
    lShow: {
        color: '#607ca7'
    }
};